"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    debug: false,
    eventQueueProcessBackoffMS: 500,
    eventSubmitRetryLimit: 4,
    eventSubmitRetryDelayMS: 1000,
    fingerprintJS: {
        apiKey: 'gfjjhJqwx5SPQy9rEFt0',
        scriptUrls: ['https://static.gala.games/gal/fp/loader_v3.8.1.js'],
    },
    apiVersionPath: '/api/v1',
    sessionExpiryTimeMs: 30 * 60 * 1000,
    sessionPingTimeDefaultMs: 60 * 1000,
    sessionPingTimeMinMs: 10 * 1000,
    sessionContextLabel: 'TS/JS_SDK_AUTO',
};
